<template>
  <div class="backgroundClass">
    <div class="loginBox">
      <img class="logo-wrap" src="/static/LogoTest.png" alt="Mountain View">
      <!-- Login -->
      <div v-if="userCreated" class="userCreatedMsg">
        {{userCreated}}
      </div>
      <input v-model="email" placeholder="E-mail" type="email" >
      <input v-model="password" placeholder="Password" type="password">
      <button type="button" v-on:click="login" :disabled="disabledActive">Log in</button>
      <router-link class="createuser" to="/choose">Opret bruger</router-link>
      <router-link class="resetPassword" to="/resetpassword">Glemt kode</router-link>
    </div>
    <transition name="fade">
      <info-modal v-if="showModal" @close="showModal = false">
        <div slot="body">{{modalInfoText}}</div>
      </info-modal>
    </transition>
  </div>
</template>

<script>
import infoModal from '@/components/infoModal.vue'
import { app } from '@/firebase'
import bus from '@/bus.js'
export default {
  data () {
    return {
      email: '',
      password: '',
      userCreated: '',
      showModal: false,
      modalInfoText: '',
      disabledActive: false
    }
  },
  methods: {
    login: function() {
      // console.log(this.disabledActive);
      this.disabledActive = true
      // console.log(this.disabledActive);
      var self = this
      app.auth().signInWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          self.disabledActive = false
          this.$router.replace('/booking')
        },
        function(error) {
          self.disabledActive = false
          var errorCode = error.code;
          var errorMessage = error.message;
          if (errorCode == 'auth/invalid-email') {
            self.disabledActive = false
            self.showModal = true
            self.modalInfoText = 'Ugyldig Email'
          } else if (errorCode == 'auth/user-disabled') {
            self.disabledActive = false
            self.showModal = true
            self.modalInfoText = 'Brugeren er deaktiveret'
          } else if (errorCode == 'auth/user-not-found') {
            self.disabledActive = false
            self.showModal = true
            self.modalInfoText = 'Brugeren blev ikke fundet'
          } else if (errorCode == 'auth/wrong-password') {
            self.disabledActive = false
            self.showModal = true
            self.modalInfoText = 'Forket password'
          } else if (errorCode == 'auth/too-many-requests') {
            self.disabledActive = false
            self.showModal = true
            self.modalInfoText = 'For mange login forsøg'
          } else {
            self.disabledActive = false
            self.showModal = true
            self.modalInfoText = 'Fejl'
            // alert(errorCode)
          }
          // alert(errorCode + errorMessage)

        }
      )
      // this.$router.replace('edit')
    }
  },
  components: {
    'info-modal': infoModal
  },
  created(){
    bus.$on('usercreated', data => {
      this.userCreated = 'Login ind med din nye bruger'
      // alert('room is ready')
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.backgroundClass {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  /* background-color: #00BAE0; */
  background: linear-gradient(rgba(0, 186, 224, 1), rgba(0, 186, 224, 0.5));
}

.loginBox {
  border-radius: 4px;
  width: 300px;
  height: 300px;

  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  margin: auto;
}

.userCreatedMsg {
  color: green;
  text-align: left;
  margin-bottom: 10px;
  font-weight: 600;
}

.createuser {
  display: inline-block;
  position: absolute;
  bottom: 5px;
  right: 5px;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  /* border: 1px solid rgba(255, 255, 255, 0.7); */
  border-radius: 2px;
  padding: 2px 0px 2px 10px;
}

.resetPassword {
  display: inline-block;
  position: absolute;
  bottom: 5px;
  left: 5px;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  /* border: 1px solid rgba(255, 255, 255, 0.7); */
  border-radius: 2px;
  padding: 2px 0px 2px 10px;
}

button {
  margin-top: 20px;
  padding: 10px 20px;
  cursor: pointer;
  /* color: #00BAE0; */
  /* color: darkgrey; */
  color: rgba(0, 0, 0, 0.6);
  border: 0;
  /* font-size: 20px; */
  font-weight: 400;
  /* background: #68b3c8; */
  background-color: white;
  border-radius: 4px;
  /* box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2); */
  box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.3);
}

input {
  margin: 6px 0;
  width: 100%;
  /* background-color: #f3f2ee; */
  /* border: 1px solid #e8e7e3; */
  border: 0px;
  border-radius: 4px;
  background-color: white;
  font-size: 16px;
  padding: 7px 18px;
  height: 40px;
}

input:focus {
  outline: none;
}

.logo-wrap {
  display: block;
  width: 100%;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/login.vue